import { render, staticRenderFns } from "./NotifyWizardNav.vue?vue&type=template&id=ca2d6ebc&"
import script from "./NotifyWizardNav.vue?vue&type=script&lang=js&"
export * from "./NotifyWizardNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports